import { render } from "./GrantPermissionCourse.vue?vue&type=template&id=bcb393dc&scoped=true"
import script from "./GrantPermissionCourse.vue?vue&type=script&lang=js"
export * from "./GrantPermissionCourse.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "@/components/modal-responsive.css?vue&type=style&index=1&id=bcb393dc&scoped=true&lang=css&external"
import "./GrantPermissionCourse.vue?vue&type=style&index=2&id=bcb393dc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb393dc"]])

export default __exports__